import { combineReducers } from 'redux'
import students from './reducers/students.js'
import subgroups from './reducers/subgroups'

export default combineReducers({
  students,
  subgroups,
})
